import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  IEditInfo,
  IReceipt,
  ReceiptRow,
  TooltipReceipt,
} from '@interfaces/models/receipt.interface';
import { BannerModule } from '@vg-constellation/angular-16/banner';
import { LinkModule } from '@vg-constellation/angular-16/link';
import { TooltipComponent, TooltipContentDirective } from '@vg-constellation/angular-16/tooltip';

import { ReceiptRowComponent } from '../receipt-row/receipt-row.component';

@Component({
  selector: '.app-receipt-section',
  templateUrl: './receipt-section.component.html',
  styleUrls: ['./receipt-section.component.scss'],
  standalone: true,
  imports: [
    TooltipComponent,
    TooltipContentDirective,
    NgClass,
    ReceiptRowComponent,
    LinkModule,
    BannerModule,
  ],
})
export class ReceiptSectionComponent {
  @Input()
  sectionData: IReceipt | TooltipReceipt;

  @Output()
  editRoute: EventEmitter<IEditInfo> = new EventEmitter<IEditInfo>();

  @Output()
  noRoutingEditing: EventEmitter<IReceipt | TooltipReceipt> = new EventEmitter<
    IReceipt | TooltipReceipt
  >();

  dynamicClass(row: ReceiptRow) {
    const borderClass = row.hideBorder ? 'hide-border' : 'show-border';
    const lineHeightClass = row.customLineHeight ? 'custom-line-height' : '';
    const hideRowClass = row.hideRow ? 'hide-row' : '';
    const positionNameClass = row.evidenceID === 'positionName' ? 'position-name' : '';
    return `${borderClass} ${lineHeightClass} ${hideRowClass} ${positionNameClass}`;
  }

  editClicked() {
    if (this.sectionData.noRoutingEdit ?? false) {
      this.noRoutingEditing.emit(this.sectionData);
      return;
    }
    this.editRoute.emit({
      editable: this.sectionData.editable,
      editRoute: this.sectionData.editRoute,
    });
  }

  removeClicked() {
    console.log('Remove clicked for section:', this.sectionData.sectionEvidenceID);
  }
}
